import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Sphere } from "@react-three/drei";

export const Satellite = ({ radius, theta, phi, offset, direction }) => {
    const ref = useRef();
    const speed = 1 / Math.cbrt(radius);
  
    useFrame(({ clock }) => {
      const elapsedTime = clock.getElapsedTime();
      ref.current.position.x = radius * Math.sin(phi) * Math.cos(direction * (theta + elapsedTime * speed + offset));
      ref.current.position.y = radius * Math.sin(phi) * Math.sin(direction * (theta + elapsedTime * speed + offset));
      ref.current.position.z = radius * Math.cos(phi);
    });
  
    return (
      <Sphere ref={ref} args={[0.5, 32, 32]}>
        <meshStandardMaterial color="white" />
      </Sphere>
    );
};

export const calculateSatelliteCount = (year) => {
    const correctedCounts = {
      2024: 1333,
      2025: 1417,
      2026: 1500,
    };

    if (year < 1960) {
      return 0;
    } else if (year >= 1960 && year <= 2008) {
      const linearSlope1 = (150 - 1) / (2008 - 1960);
      return Math.round(1 + linearSlope1 * (year - 1960));
    } else if (year >= 2008 && year <= 2013){
      return ((192) - 7*(2014-year))
    } else if (year === 2014){
      return (192)
    } else if (correctedCounts[year]) {
      return correctedCounts[year];
    } else {
        const base = 192; // number of satellites in 2014
        const targetYear = 2023; 
        const targetCount = 1250; // number of satellites in 2023
        const exponentialRate = Math.log(targetCount / base) / (targetYear - 2014);
        return Math.round(base * Math.exp(exponentialRate * (year - 2014)));
    }
  };
  
  export const generateSkewedNumber = (mean, stdevLeft, stdevRight) => {
    let u = Math.random() - 0.5;  
    let sigma = u < 0 ? stdevLeft : stdevRight;
    return mean + sigma * Math.sqrt(12) * u;
};
  
  export const precomputeSatelliteCounts = () => {
    let counts = {};
    const currentYear = new Date().getFullYear();
    for (let year = 1960; year <= currentYear; year++) {
      counts[year] = calculateSatelliteCount(year);
    }
    return counts;
  }
  
